import { objectIdSchema } from "./commonSchemas";

export const emitSchemaTypes = true;

export let UserRole;(function (UserRole) {UserRole["ADMIN"] = "admin";UserRole["EDITOR"] = "editor";UserRole["COLLABORATOR"] = "collaborator";})(UserRole || (UserRole = {}));





export const userSchema = {
  type: 'object',
  additionalProperties: false,
  definitions: { objectIdSchema },
  properties: {
    _id: objectIdSchema,
    __v: { type: 'number' },
    username: { type: 'string', minLength: 1 },
    role: { type: 'string', enum: Object.values(UserRole) },
    email: { type: 'string', minLength: 1 },
    password: { type: 'string', minLength: 1 },
    using2fa: { type: 'boolean' },
    groups: {
      type: 'array',
      items: {
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: objectIdSchema,
          name: { type: 'string' }
        },
        required: ['_id', 'name']
      }
    }
  },
  required: ['username', 'role', 'email']
};